// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-bg[data-v-367c4727]{position:absolute;top:0;left:0;width:100%;height:100%}.video-bg img[data-v-367c4727],.video-bg video[data-v-367c4727]{position:absolute;top:0;left:0;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
